import React from "react";
import { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Button } from "react-bootstrap";
import cx from "classnames";
import { connect } from "react-redux";
import withStyles from "isomorphic-style-loader/withStyles";


import { closeHeaderModal } from "../../../actions/siteadmin/modalActions";
import { clearOrderItemAction } from "../../../actions/order/clearOrderItemAction";
import messages from "../../../locale/messages";

import bt from '../../commonStyle.css';

const ClearCart = ({ closeHeaderModal, clearOrderItemAction, resetForm, orderId }) => {

    const handleClick = () => {
        clearOrderItemAction(orderId)
        resetForm()
        closeHeaderModal('clearCart')
    }
    return (
        <>
            <p className={cx(bt.commonSize14, bt.fontWeight400, bt.primaryColor)}><FormattedMessage {...messages.clearCartContent} /></p>
            <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                <Button className={bt.btnSecondary} onClick={() => closeHeaderModal('clearCart')}><FormattedMessage {...messages.cancelButton} /></Button>
                <Button className={bt.btnPrimary} onClick={handleClick}><FormattedMessage {...messages.clear} /></Button>
            </div>
        </>
    )
}
const mapState = (state) => {

}
const mapDispatch = {
    closeHeaderModal,
    clearOrderItemAction
}
export default injectIntl(withStyles(bt)(connect(mapState, mapDispatch)(ClearCart)))